var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "iconamoon:sign-plus-fill"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.25 7.5C16.25 7.16848 16.1183 6.85054 15.8839 6.61612C15.6495 6.3817 15.3315 6.25 15 6.25C14.6685 6.25 14.3505 6.3817 14.1161 6.61612C13.8817 6.85054 13.75 7.16848 13.75 7.5V13.75H7.5C7.16848 13.75 6.85054 13.8817 6.61612 14.1161C6.3817 14.3505 6.25 14.6685 6.25 15C6.25 15.3315 6.3817 15.6495 6.61612 15.8839C6.85054 16.1183 7.16848 16.25 7.5 16.25H13.75V22.5C13.75 22.8315 13.8817 23.1495 14.1161 23.3839C14.3505 23.6183 14.6685 23.75 15 23.75C15.3315 23.75 15.6495 23.6183 15.8839 23.3839C16.1183 23.1495 16.25 22.8315 16.25 22.5V16.25H22.5C22.8315 16.25 23.1495 16.1183 23.3839 15.8839C23.6183 15.6495 23.75 15.3315 23.75 15C23.75 14.6685 23.6183 14.3505 23.3839 14.1161C23.1495 13.8817 22.8315 13.75 22.5 13.75H16.25V7.5Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.82b0b52beede2e20c3bd59fadca5f800.svg";
export { ForwardRef as ReactComponent };